import { environment } from "src/environments/environment";

export const getThemeLang = (): any => {
  let lang;
  try {
    lang = localStorage.getItem("theme_lang") ?? environment.defaultLang;
    localStorage.setItem("direction", "ltr");
  } catch (error) {
    lang = environment.defaultLang;
    localStorage.setItem("direction", "ltr");
  }
  return lang;
};
export const setThemeLang = (lang: any, direction: any): any => {
  try {
    localStorage.setItem("theme_lang", lang);
    localStorage.setItem("direction", direction);
  } catch (error) {
    localStorage.setItem("theme_lang", environment.defaultLang);
    localStorage.setItem("direction", "ltr");
  }
};
